import {
  LIST_GRILLE_FAIL,
  LIST_GRILLE_SUCCESS,
  CREATEGRILLE_FAIL,
  CREATEGRILLE_SUCCESS,
  ONE_GRILLE_FAIL,
  ONE_GRILLE_SUCCESS,
  OPEN_GRILLE_SUCCESS,
  DEACTIVATE_GRILLE_SUCCESS,
  DEACTIVATE_GRILLE_FAIL,
  UPDATE_GRILLE_SUCCESS,
  UPDATE_GRILLE_FAIL,
  CLEAR_DATA_GRILLE,
  LIST_GRIDS_SUCCESS,
  LIST_All_GRIDS_FAIL,
  LIST_GRILLE_Desactiver_SUCCESS,LIST_GRILLE_Desactiver_FAIL, SEARCH_GRILLE_SUCCESS, SEARCH_GRILLE_FAIL, REMOVE_CRITERIA_VALUES_SUCCESS
} from "../../actions/grille/type";

const initialState = {
  datagrilles: {},
  datagrille: {},
  listGrids : {},
  datagrilleselecet: {},
  datagrillesdesactiver:{},
  criteriaValueId: null
};

const grilleReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case LIST_GRILLE_SUCCESS:
      return {
        ...state,
        datagrilles: payload,
      };
    case LIST_GRIDS_SUCCESS:
      return {
        ...state,
        listGrids : payload,
      }
    case LIST_All_GRIDS_FAIL:
      return {
        ...state,
      }
      case LIST_GRILLE_Desactiver_SUCCESS:
        return {
          ...state,
          datagrilles: payload,
        };
        case LIST_GRILLE_Desactiver_FAIL:
          return {
            ...state,
          };
    case LIST_GRILLE_FAIL:
      return {
        ...state,
      };
    case CREATEGRILLE_SUCCESS:
      return {
        ...state,
        datagrilles: payload,
      };
    case CREATEGRILLE_FAIL:
      return {
        ...state,
      };
    case ONE_GRILLE_SUCCESS:
      return {
        ...state,
        datagrille: payload,
      };
    case ONE_GRILLE_FAIL:
      return {
        ...state,
      };
    case OPEN_GRILLE_SUCCESS:
      return {
        ...state,
        datagrilleselecet: payload.datagrilleselecet,
      };
    case CLEAR_DATA_GRILLE:
      return {
        datagrille: {},
      };
  
    case DEACTIVATE_GRILLE_SUCCESS:
      return {
        ...state,
       datagrilles:{ ...state.datagrilles, grids: state.datagrilles.grids.filter((item) => item.id !== payload)},
      };
    case DEACTIVATE_GRILLE_FAIL:
      return {
        ...state,
        // idg: payload.id,
      };
      case UPDATE_GRILLE_SUCCESS:
        return {
          ...state,
          datagrilles: payload,
        };
        case UPDATE_GRILLE_FAIL:
        return {
          ...state,
        };
    case SEARCH_GRILLE_SUCCESS:
      return {
        ...state,
        datagrilles: payload,
      };
    case SEARCH_GRILLE_FAIL:
      return {
        ...state,
      };
    case REMOVE_CRITERIA_VALUES_SUCCESS:
      return {
        ...state,
        criteriaValueId: payload,
      };
    default:
      return state;
  }
};

export default grilleReducer;
